import Model from "../classes/Model";
import CompanyApi from "../classes/api/Company";
import ValidationError from "../classes/ValidationError";

export default class Company extends Model {

    get image() {
        return this._image;
    }
    set image(value) {
        this._image = value;
    }

    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
    }

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get id() {
        return this._id;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    static getList(page = 1, perPage = 10) {
        return CompanyApi.getList(page, perPage).then((response) => {
            let data = [];
            for (let company of response.data) {
                data.push(new this({
                    id: company.id,
                    name: company.name,
                    status: company.status,
                    image: {
                        image: company.image,
                        small: company.image_small,
                    }
                }));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return CompanyApi.get(id).then(({data}) => {
            return new this({
                id: Number(id),
                name: data.name,
                status: data.status,
                image: {
                    image: data.image,
                    small: data.image_small,
                }
            });
        });
    }

    static add(name, status) {
        return CompanyApi.add({name: name, status: status}).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return new this({id: data.id, name: name, status: status});
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return CompanyApi.update({
            id: this.id,
            name: this.name,
            status: this.status,
        }).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    updateImage(file) {
        return CompanyApi.updateAvatar(this.id, file).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            this.image.image = data.avatar;
            this.image.small = data.avatar_small;
            return true;
        });
    }
}